import React from "react"
import tw, { styled, css } from "twin.macro"
import Link from "next/link"
import { ReactComponent as MeSVG } from "../../assets/nav/me.svg"
import ProfilePhoto, { Width } from "../profilePhoto"
import { PreflightData } from "../../utils/context"
import { Routes } from "../../routes"
import { useRouter } from "next/router"
import { isMobile } from "react-device-detect"

const MeDot = styled(MeSVG)(() => [
  css`
    path {
      fill: #29314b;
    }
  `,
])

const StyleProfileLink = styled("a")(() => [
  tw`w-full flex justify-center items-center space-x-2 py-4 tablet-lg:(py-0)`,
  css`
    &:hover > span {
      ${tw`border-purple no-underline`}
    }
  `,
])

interface ProfileIconProps {
  preflightData: PreflightData | undefined
  isblack?: boolean
  showMenu: boolean
  setShowMenu: React.Dispatch<React.SetStateAction<boolean>>
}
export const ProfileIcon = ({ preflightData, isblack, showMenu, setShowMenu }: ProfileIconProps) => {
  const router = useRouter()
  // If there is preflightData, then use that to create the profile Icon
  // Otherwise, show the Me Dot icon
  if (!!preflightData) {
    const { name, profilePictureUrl, username } = preflightData.data.Preflight
    const src = !!profilePictureUrl ? profilePictureUrl : "default_2.png"
    const isActive =
      router && !!username && (router.asPath.includes(`${Routes.EditProfile}`) || router.asPath.includes(username))

    const profilePhoto = (
      <ProfilePhoto
        twStyle={isblack ? tw`border-white` : tw`border-base-6`}
        name={name || ""}
        username={username || ""}
        profilePictureUrl={src}
        width={isMobile ? Width.W24 : Width.W42}
        isActive={isActive}
      />
    )

    return (
      // keeping track of some ridiculous logics just for profile photo on nav bar!!!!!!!!!!!!
      // All logics below are achieved in different components based on mocks.

      // a) profile photo shows white border on desktop nav bar
      // b) profile photo shows black on mobile drop down
      // c) profile photo only links to profile in desktop
      // d) profile photo doesn't link to profile in mobile
      // e) profile photo shows drop down in mobile
      // f) profile photo doesn't show drop down in desktop
      // g) profile photo shows drop down on mobile when drop down is closed
      // h) profile photo switches to link to profile when drop down is open
      // i) profile photo shows purple border when the User is viewing his profile
      // j) profile photo shows black border when the User is not viewing his profile
      <>
        {isMobile && !showMenu ? (
          <span onClick={() => setShowMenu(!showMenu)}>{profilePhoto}</span>
        ) : (
          <Link href={{ pathname: Routes.Profile, query: { username } }} passHref>
            <StyleProfileLink title="My profile" data-testid="nav-profile">
              {profilePhoto}
              <span tw="tablet-lg:hidden">Profile</span>
            </StyleProfileLink>
          </Link>
        )}
      </>
    )
  }
  // if preflight is not loaded
  return <MeDot />
}
